import { IsProd } from "@/constants/config";
import request from "@/utils/request";

const PATH_PREFIX = IsProd ? "/v1/" : "/vb/";

export const flightTaskCrawlerV2 = (data: { tasks: any[]; query: string; raw_path: string }) => {
  return request.post(PATH_PREFIX + "task_crawler_v2", {
    ...data,
  });
};
